import ReactDOM from 'react-dom/client';
import Main from './Pages/Main/Main';
import './resources/css/style.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Main />);
